export default {"src":"/_next/static/media/rbi.0bd6c40d.svg","height":85,"width":244,"blurWidth":0,"blurHeight":0};